import {
  buildCountryRouteCandidates,
  buildForexLatestRouteCandidates,
} from "./storefront-internal-routes"

type CountrySelectionSyncPayload = {
  country?: string
  countryCode?: string
  selectedCountry?: string
  currency?: string
  cookieMaxAgeDays?: number
  manualSelection?: boolean
  preserveCurrency?: boolean
}

type CountrySelectionSyncResponse = {
  country?: string
  currency?: string
  international?: boolean
  manualSelection?: boolean
}

const dedupeUrls = (urls: string[]): string[] => {
  const seen = new Set<string>()
  const unique: string[] = []
  for (const url of urls) {
    const normalized = String(url || "").trim()
    if (!normalized || seen.has(normalized)) continue
    seen.add(normalized)
    unique.push(normalized)
  }
  return unique
}

const fetchFirstSuccessfulJson = async <T>(
  urls: string[],
  init: RequestInit
): Promise<T | null> => {
  for (const url of dedupeUrls(urls)) {
    try {
      const response = await fetch(url, init)
      if (!response.ok) continue
      const payload = (await response.json().catch(() => null)) as T | null
      if (payload) return payload
    } catch {
      // ignore and continue to next fallback
    }
  }
  return null
}

export const syncCountrySelection = async (
  payload: CountrySelectionSyncPayload
): Promise<CountrySelectionSyncResponse | null> => {
  return fetchFirstSuccessfulJson<CountrySelectionSyncResponse>(
    buildCountryRouteCandidates(),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      cache: "no-store",
    }
  )
}

export const fetchLatestForexSnapshot = async <
  T extends Record<string, unknown> = Record<string, unknown>,
>(): Promise<T | null> => {
  return fetchFirstSuccessfulJson<T>(buildForexLatestRouteCandidates(), {
    method: "GET",
    cache: "no-store",
  })
}
